// Raggruppa le webcam vicine mantenendo l'ancora geografica di una webcam reale.
// L'ordine stabile evita salti; tutti i membri restano selezionabili nel popup.
export function layoutWebcamPoints(points, minDistance = 78) {
    const groups = [];
    for (const point of points) {
        const group = groups.find(other => Math.hypot(point.x - other.x, point.y - other.y) < minDistance);
        if (group) group.members.push(point);
        else groups.push({ ...point, members: [point] });
    }
    return groups;
}
